
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SoftwareLegal from "../pages/software-legal/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/software-legal",
    element: <SoftwareLegal />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
